import dynamic from 'next/dynamic';
import { useState } from 'react';

import FlatLayout from 'components/Layout/FlatLayout';

import CouponsListGameTab from '../CouponsListGameTab';
import Head from '../Head';
import OffersListGameTab from '../OffersListGameTab';
import SavingGameTimelineTabs from './SavingGameTimelineTabs';

import BLACK_FRIDAY from 'constants/blackFriday';

const FloatProgressGameBarButton = dynamic(
  () => import('../FloatProgressGameBarButton'),
  { ssr: false }
);

const SavingGameCards = dynamic(() => import('./SavingGameCards'), {
  ssr: false,
});

const SavingGamePage = () => {
  const [activeTab, setActiveTab] = useState(
    BLACK_FRIDAY.MY_BF_PAGE.SAVING_GAME_TAB
  );

  return (
    <>
      <Head />
      <FlatLayout.Margin className="!pt-4 lg:mb-0">
        <FlatLayout.Body className="relative flex flex-col gap-4 lg:gap-6 3xl:pt-14">
          <SavingGameTimelineTabs
            activeTab={activeTab}
            gaEventCategory={BLACK_FRIDAY.MY_BF_PAGE.GA_EVENT_CATEGORY}
            setActiveTab={setActiveTab}
          />
          {activeTab === BLACK_FRIDAY.MY_BF_PAGE.SAVING_GAME_TAB && (
            <SavingGameCards
              gaEventCategory={BLACK_FRIDAY.MY_BF_PAGE.GA_EVENT_CATEGORY}
              setActiveTab={setActiveTab}
            />
          )}
          {activeTab === BLACK_FRIDAY.MY_BF_PAGE.OFFERS_TAB && (
            <OffersListGameTab
              gaEventCategory={BLACK_FRIDAY.MY_BF_PAGE.GA_EVENT_CATEGORY}
            />
          )}
          {activeTab === BLACK_FRIDAY.MY_BF_PAGE.COUPONS_TAB && (
            <CouponsListGameTab
              gaEventCategory={BLACK_FRIDAY.MY_BF_PAGE.GA_EVENT_CATEGORY}
            />
          )}
          <FloatProgressGameBarButton className="fixed bottom-0 left-1/2 -translate-x-2/4 px-1 lg:hidden" />
        </FlatLayout.Body>
      </FlatLayout.Margin>
    </>
  );
};

export default SavingGamePage;
